import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Container = styled.div`
    ${FlexCentered};
    border-radius: 50%;
    width: 100%;
    height: 100%;
    display: none;
`

export const NetworkImage = styled.img`
    width: 100%;
    height: 100%;
`
